export const renderImage = (url: string, width: number, height?: number, type?: string) => {
  if (!url || typeof url !== 'string') return '';
  if (!url?.startsWith('https://res.cloudinary.com/')) return url;
  const userUrlArray = url.split('/upload/');
  if (userUrlArray[1].includes('c_crop')) {
    const transforms = userUrlArray[1].split('/v');
    return `${userUrlArray[0]}/upload/${transforms[0]}/c_fill,w_${width}${
      height ? `,h_${height}` : ''
    },c_limit,f_auto,q_auto,dpr_2.0/v${transforms[1]}`;
  }
  return `${userUrlArray[0]}/upload/${type === 'icon' ? 'c_lpad,' : 'c_fill,'}w_${width}${
    height ? `,h_${height}` : ''
  },${type === 'icon' ? '' : 'c_limit,'}f_auto,q_auto,dpr_2.0/${userUrlArray[1]}`;
};
